/**
 * testCodes.ts — stable dispatch slugs for lab `Test` rows (BUG-2026-0197).
 *
 * The frontend mirror of `backend/src/constants/testCodes.ts`. Every workflow
 * dispatch (TestWorkflowPage router, ResultEntryRouter, evidence + splash
 * resolution, the "implemented" gate) keys on `TestCode`, delivered on the WOD
 * context / test-listing payloads. `TestName` is display-only; renaming a test
 * in the admin Test Catalogue never changes its code, so dispatch is stable.
 */

export const TEST_CODES = {
  directShear: 'directShear',
  atterberg: 'atterberg',
  psd: 'psd',
  pointLoad: 'pointLoad',
  rockBts: 'rockBts',
  rockTcs: 'rockTcs',
  cerchar: 'cerchar',
  rockUcsNs: 'rockUcsNs',
  rockUcs: 'rockUcs',
  triaxialCu: 'triaxialCu',
  triaxialCd: 'triaxialCd',
} as const;

export type TestCode = (typeof TEST_CODES)[keyof typeof TEST_CODES];

/** Test codes whose full data-entry workflow is implemented (dispatch gate). */
export const IMPLEMENTED_TEST_CODES: ReadonlySet<string> = new Set<string>([
  TEST_CODES.directShear,
  TEST_CODES.atterberg,
  TEST_CODES.psd,
  TEST_CODES.triaxialCu,
  TEST_CODES.triaxialCd,
  TEST_CODES.rockTcs,
  TEST_CODES.rockBts,
  TEST_CODES.rockUcsNs,
  TEST_CODES.rockUcs,
  TEST_CODES.pointLoad,
  TEST_CODES.cerchar,
]);
